export const SET_DATE_RANGE_FILTER = 'filtering.set-date-range'

export const setDateRangeFilter = (dateRange, key) => ({
  type: SET_DATE_RANGE_FILTER,
  payload: { dateRange, key },
})
